module.exports = __webpack_public_path__ + "media/svg/chart-d544a10d.svg";